import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ValidateJobTerminalsAndLocationRequest } from "../../domain";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class ValidateJobTerminalsAndLocationUsecase implements UseCase<ValidateJobTerminalsAndLocationRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: ValidateJobTerminalsAndLocationRequest): Observable<boolean> {
    return this.jobRepository.JobTerminalsAndLocationsCheck(params);
  }

}
